// Light/dark theme. Honours the saved choice, else the OS preference.
// Theme is a UI preference — safe in localStorage (not credentials/PII).
import { signal } from './t4.js';

const KEY = 'sleek_theme';

function initial(){
  try { return localStorage.getItem(KEY) || (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'); }
  catch { return 'light'; }
}

export const theme = signal(initial());

function apply(t){ document.documentElement.setAttribute('data-theme', t); }
apply(theme.value);   // apply on import (before first render → no flash)

export function toggleTheme(){
  const t = theme.value === 'dark' ? 'light' : 'dark';
  theme.value = t;
  try { localStorage.setItem(KEY, t); } catch {}
  apply(t);
}
